import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Table, Space, Tooltip, Button, PageHeader, Tag } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
  TagsOutlined,
} from "@ant-design/icons";
import { handleApiSuccess, handleApiError, MyBreadcrumb, confirmDelete } from "utils";
import {
  billingCategoryListService,
  billingCategoryDeleteService,
} from "services/billing";

export default function CategoryIndex() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);

  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Description", dataIndex: "description", key: "description" },
    {
      title: "Active",
      dataIndex: "is_active",
      key: "is_active",
      render: (t) =>
        t === false ? <Tag>Inactive</Tag> : <Tag color="green">Active</Tag>,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Tooltip title="Edit">
            <Button
              onClick={() => history.push("/billing/categories/update/" + record._id)}
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              onClick={() => deleteRecord(record._id)}
              shape="circle"
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setIsLoading(true);
    billingCategoryListService()
      .then((response) => {
        setIsLoading(false);
        setDataSource(response.data.items || []);
      })
      .catch((error) => {
        setIsLoading(false);
        handleApiError(error);
      });
  };

  const deleteRecord = (id) => {
    confirmDelete().then(() => {
      setIsLoading(true);
      billingCategoryDeleteService(id)
        .then((response) => {
          handleApiSuccess(response);
          loadData();
        })
        .catch((error) => {
          setIsLoading(false);
          handleApiError(error);
        });
    });
  };

  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Categories", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <TagsOutlined /> }}
        title="Part / Service Categories"
        subTitle="Groups such as Phones, Tech Support, Websites, and Parts"
        extra={[
          <Button
            key="create"
            shape="round"
            onClick={() => history.push("/billing/categories/create")}
            type="primary"
            icon={<PlusCircleOutlined />}
          >
            Add Category
          </Button>,
        ]}
      />
      <Table
        dataSource={dataSource}
        columns={columns}
        loading={isLoading}
        rowKey="_id"
      />
    </div>
  );
}
